<script lang="ts" setup>
import type { IconIdentifier } from '~ds/lib/icon-types';

import { Heading } from '~ds/components/ui/typography';
import KUISchoolsLandingStepCard from '~kui/components/KUI/Schools/LandingStepCard/KUISchoolsLandingStepCard.vue';

export interface SchoolsLandingStepCard {
  key: string;
  icon: IconIdentifier;
  title: string;
  description: string;
}

interface Props {
  title: string;
  /** The badge every card in the row carries, e.g. "Available". */
  label: string;
  cards: SchoolsLandingStepCard[];
}

defineProps<Props>();
</script>

<template>
  <section class="flex flex-col gap-12">
    <Heading
      as="h2"
      size="3xl"
      class="mx-auto max-w-4xl text-center"
      data-testid="schools-landing-step-card-section-title"
    >
      {{ title }}
    </Heading>

    <div class="grid grid-cols-1 items-stretch gap-6 sm:grid-cols-3">
      <KUISchoolsLandingStepCard
        v-for="card in cards"
        :key="card.key"
        :icon="card.icon"
        :title="card.title"
        :description="card.description"
        :label="label"
      />
    </div>
  </section>
</template>
